import Vue from 'vue';
import mixpanel from 'mixpanel-browser';
Vue.prototype._mixpanel = mixpanel;
const debugMode = process.env.NODE_ENV === 'development';
mixpanel.init(process.env.VUE_APP_MIXPANEL_ID, { debug: debugMode });
